import { render, staticRenderFns } from "./ReportMotoristLegalInsurance.vue?vue&type=template&id=1d2957a3"
import script from "./ReportMotoristLegalInsurance.vue?vue&type=script&lang=ts"
export * from "./ReportMotoristLegalInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports